const GRID_SELECTOR = ".wj-flexgrid";
const DATA_CELL_SELECTOR = ".wj-cells .wj-cell";
const HOVER_CLASS = "wj-row-hover";

export const initializeWijmoRowHover = () => {
  let activeGrid = null;
  let activeRowTop = null;
  let activeCells = [];

  const clearActiveRow = () => {
    activeCells.forEach((cell) => cell.classList.remove(HOVER_CLASS));
    activeGrid = null;
    activeRowTop = null;
    activeCells = [];
  };

  const handleMouseOver = (event) => {
    if (!(event.target instanceof Element)) return;

    const grid = event.target.closest(GRID_SELECTOR);
    const cell = event.target.closest(".wj-cell");
    const cellsPanel = cell?.closest(".wj-cells");

    if (!grid || !cell || !cellsPanel || !grid.contains(cellsPanel)) {
      if (!grid || grid === activeGrid) clearActiveRow();
      return;
    }

    const rowTop = cell.offsetTop;
    if (grid === activeGrid && rowTop === activeRowTop) return;

    clearActiveRow();

    activeGrid = grid;
    activeRowTop = rowTop;
    activeCells = Array.from(grid.querySelectorAll(DATA_CELL_SELECTOR)).filter(
      (dataCell) => dataCell.offsetTop === rowTop
    );
    activeCells.forEach((dataCell) => dataCell.classList.add(HOVER_CLASS));
  };

  const handleMouseOut = (event) => {
    if (!activeGrid) return;

    const nextTarget = event.relatedTarget;
    if (!(nextTarget instanceof Node) || !activeGrid.contains(nextTarget)) {
      clearActiveRow();
    }
  };

  const handleScroll = (event) => {
    if (activeGrid?.contains(event.target)) clearActiveRow();
  };

  document.addEventListener("mouseover", handleMouseOver, true);
  document.addEventListener("mouseout", handleMouseOut, true);
  document.addEventListener("scroll", handleScroll, true);

  return () => {
    clearActiveRow();
    document.removeEventListener("mouseover", handleMouseOver, true);
    document.removeEventListener("mouseout", handleMouseOut, true);
    document.removeEventListener("scroll", handleScroll, true);
  };
};
